import { HttpEndpoint } from '../httpEndpoints';
import {
    MyBookingStaticContentEndpoint as MyBookingStaticContentEndpointModel,
    StaticBookingContent,
} from '@/api/MyBookingStaticContent/myBookingStaticContent.interfaces';
import { fakeMyBookingStaticContent } from '@/api/MyBookingStaticContent/myBookingStaticContent.fake';
import { delay } from '@shared/utils/async';

export class MyBookingStaticContentEndpoint
    extends HttpEndpoint
    implements MyBookingStaticContentEndpointModel
{
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async GetStaticBookingPageContent(): Promise<StaticBookingContent> {
        return await this.get<StaticBookingContent>(
            'mvc/MyBookingPage/GetStaticBookingPageContent'
        );
    }
}

export class FakeMyBookingStaticContentEndpoint
    extends HttpEndpoint
    implements MyBookingStaticContentEndpointModel
{
    public async GetStaticBookingPageContent(): Promise<StaticBookingContent> {
        await delay(600);
        return fakeMyBookingStaticContent;
    }
}
